import React from "react";
import moment from 'moment';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  List,
  ListItem
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Icon } from "@iconify/react";

// Sample Data (Replace with API Response)


function PentestReport({ data, pageTitle }) {
  return (
    <Paper elevation={3} sx={{ padding: 3, width: "100%", maxWidth: 900, margin: '0 auto' }}>
      <Box >
      {/* Title & Target */}
      <Typography variant="h4" fontWeight="bold" mb={3} color="rgb(0, 145, 70)" sx={{ textAlign: 'center' }}>
        {pageTitle}
      </Typography>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography variant="h6" fontWeight="bold">
          <Icon icon="mdi:web" width={24} height={24} style={{ marginRight: 8 }} />
          Target:
        </Typography>
        <Chip label={data?.result?.url} color="primary" variant="outlined" sx={{ fontSize: "1rem", padding: "5px" }} />
      </Box>
      <Typography variant="body1" sx={{ color: "#777", mb: 2 }}>
        Report Date: {moment(data?.date).format('MMM DD, YYYY HH:mm')}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      {/* Priority Count Summary */}
      <Card sx={{ mt: 2, mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Risk Breakdown
          </Typography>
          <Grid container spacing={2}>
            {Object.entries(data.result.priorityCount).map(([priority, count]) => (
              <Grid item xs={6} sm={3} key={priority}>
                <Chip
                  label={`${priority.charAt(0).toUpperCase() + priority.slice(1)}: ${count}`}
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "bold",
                    backgroundColor:
                      priority === "high"
                        ? "red"
                        : priority === "medium"
                        ? "orange"
                        : priority === "low"
                        ? "yellow"
                        : "gray",
                    color: "#000",
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>

      {/* Vulnerabilities List */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Identified Vulnerabilities
          </Typography>
          {data.result.vulnerabilities.map((vuln, index) => (
            <Accordion key={index} sx={{ mb: 1 }} defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  {vuln.risk} ({vuln.priority})
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" sx={{ mb: 1 }} dangerouslySetInnerHTML={{ __html: vuln.desc }} />
                <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
                  Solution:
                </Typography>
                <Typography variant="body2" dangerouslySetInnerHTML={{ __html: vuln.solution }} />
                <Typography variant="body2" sx={{ fontWeight: "bold", mt: 1 }}>
                  Affected Locations:
                </Typography>
                <List dense>
                  {vuln.locations.map((loc, i) => (
                    <Typography variant="body2" key={i}>
                      🔗 <a href={loc} target="_blank" rel="noopener noreferrer">
                        {loc}
                      </a>
                    </Typography>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>
          ))}
        </CardContent>
      </Card>

      {/* Wapiti Vulnerabilities Table */}
      {/* <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Wapiti Vulnerabilities
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Path</strong></TableCell>
                  <TableCell><strong>Risk</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.result.wapitiVulnerabilities.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.path}</TableCell>
                    <TableCell>{item.risk}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card> */}
    </Box></Paper>
  );
}

export default PentestReport;
